import React from 'react';
import AbstractComponent from '../AbstractComponent';
import InputSelect from '../layout/input/InputSelect';

class InputSelectCliente extends  AbstractComponent {       
    onChangeSelect(input) {
        let empresa = {};
        let lista = this.props.clientes;        

        for(var i = 0; i < lista.length; i++) {                        
            if(parseInt(lista[i].valor, 10) === parseInt(input.target.value, 10)) 
                empresa = lista[i].empresa;                            
        }

        if (this.props.onChange !== undefined) 
            this.props.onChange(empresa);   
    }       

    render () {
        return (                                               
            <InputSelect
                md={12}
                xs={12}
                sm={12}
                lg={12}         
                className="row"                           
                classNameInput="background-transparent"                                          
                id="id"
                nome="id"
                defaultFoco={true}                                    
                value={this.props.form.id}
                defaultValue={this.props.form.id}
                options={this.props.clientes}                            
                erro={this.props.erroForm.id}                                
                onChange={e => this.onChangeSelect(e)}                    
            >
                Empresa
            </InputSelect>            
        )   
    }
}

export default InputSelectCliente;